
import { SvgIcon } from '@mui/material';
import type { SvgIconProps } from '@mui/material/SvgIcon'

export const ShareIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props} viewBox="0 0 36 36" fill="none" >
            <path d="M10.0716 22.7558C12.6981 22.7558 14.8273 20.6266 14.8273 18C14.8273 15.3735 12.6981 13.2443 10.0716 13.2443C7.44503 13.2443 5.3158 15.3735 5.3158 18C5.3158 20.6266 7.44503 22.7558 10.0716 22.7558Z"  strokeWidth="2" strokeMiterlimit="10" />
            <path d="M25.9284 12.7556C28.5549 12.7556 30.6841 10.6264 30.6841 7.99985C30.6841 5.37331 28.5549 3.24408 25.9284 3.24408C23.3018 3.24408 21.1726 5.37331 21.1726 7.99985C21.1726 10.6264 23.3018 12.7556 25.9284 12.7556Z"  strokeWidth="2" strokeMiterlimit="10" />
            <path d="M25.9284 32.7559C28.5549 32.7559 30.6841 30.6267 30.6841 28.0002C30.6841 25.3736 28.5549 23.2444 25.9284 23.2444C23.3018 23.2444 21.1726 25.3736 21.1726 28.0002C21.1726 30.6267 23.3018 32.7559 25.9284 32.7559Z"  strokeWidth="2" strokeMiterlimit="10" />
            <path d="M14.0929 15.4639L21.9055 10.5369" strokeWidth="2" strokeMiterlimit="10" />
            <path d="M14.0928 20.536L21.907 25.464" strokeWidth="2" strokeMiterlimit="10" />
        </SvgIcon>
  )
}